<div class="container" [class.minified]="isMinified">
  @if (isMinified) {
    <div
      class="w-full flex flex-col justify-center items-center action-menu-toggle box-content"
      (click)="open.emit()"
      >
      <i class="fa-regular fa-ellipsis-vertical actions-icon"></i>
      <span class="action-menu-toggle-name">{{
        '#SHELL.ACTIONS' | translate
      }}</span>
    </div>
  }
  @if (!isMinified) {
    <div class="action-menu-header">
      <span class="font-semibold">{{ '#SHELL.ACTIONS' | translate }}</span>
      <span class="action-menu-close" (click)="close.emit()">
        <i class="fa-regular fa-xmark"></i>
      </span>
    </div>
  }
  <div class="w-full h-full flex flex-col justify-between items-stretch vertical no-horizontal">
    <soft-menu-outlet name="action" #action></soft-menu-outlet>

    @for (command of topCommands$ | async; track command) {
      @if (command.isVisible ? (command.isVisible | async) : true) {
        <div
          [id]="'framework-application-shell-actions-commands-bottom-' + command.name"
          class="flex flex-row menu-item flex-nowrap relative"
          softToolTip="{{ command.name | translate }}"
          toolTipPosition="left"
          [toolTipVisible]="isMinified"
          *ngVar="
            command.canExecute
              ? (command.canExecute | async)
              : true as canExecute
          "
          [routerLinkActive]="command.routerLink ? 'active' : ''"
          [routerLinkActiveOptions]="{ exact: true }"
          [class.disabled]="!canExecute"
          [ngClass]="command.class"
          (click)="
            onClick(
              command.execute,
              command.routerLink,
              canExecute,
              command.routerLinkParams
            )
          "
          >
          @if (command?.badge | async; as badge) {
            <span class="soft-badge">{{ badge }}</span>
          }
          @if (command.icon) {
            <span
              class="flex flex-row justify-center command-icon"
              [class.minified]="isMinified"
              >
              <soft-icon [name]="command.icon"></soft-icon>
            </span>
          }
          @if (!isMinified) {
            <span class="ml-2">{{
              command.name | translate
            }}</span>
          }
        </div>
      }
    }

    <div class="menu-container-bottom">
      <soft-menu-outlet name="action-bottom" #actionBottom></soft-menu-outlet>
      @for (command of bottomCommands$ | async; track command) {
        @if (command.isVisible ? (command.isVisible | async) : true) {
          <div
            [id]="'framework-application-shell-actions-commands-bottom-' + command.name"
            class="flex flex-row menu-item flex-nowrap relative"
            softToolTip="{{ command.name | translate }}"
            toolTipPosition="left"
            [toolTipVisible]="isMinified"
            *ngVar="
              command.canExecute
                ? (command.canExecute | async)
                : true as canExecute
            "
            [routerLinkActive]="command.routerLink ? 'active' : ''"
            [routerLinkActiveOptions]="{ exact: true }"
            [class.disabled]="!canExecute"
            [ngClass]="command.class"
            (click)="
              onClick(
                command.execute,
                command.routerLink,
                canExecute,
                command.routerLinkParams
              )
            "
            >
            @if (command?.badge | async; as badge) {
              <span class="soft-badge">{{ badge }}</span>
            }
            @if (command.icon) {
              <span
                class="flex flex-row justify-center command-icon"
                [class.minified]="!isMinified"
                >
                <soft-icon [name]="command.icon"></soft-icon>
              </span>
            }
            @if (!isMinified) {
              <span class="ml-2">{{
                command.name | translate
              }}</span>
            }
          </div>
        }
      }
    </div>
  </div>
</div>
